export default __webpack_public_path__ + "static/media/discount.8bda326f.svg";